import { Component, OnInit, Input, AfterViewInit, HostListener, input, signal } from '@angular/core';

import { ShopOffersInventory } from '@app/shared/models/inventory.model';
import { User } from '@shared/models/user.model';
import { ShopItemComponent } from '../shop-item/shop-item.component';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'slotcom-anchor-tab-display',
  templateUrl: './anchor-tab-display.component.html',
  styleUrls: ['./anchor-tab-display.component.scss'],
  standalone: true,
  imports: [ShopItemComponent, SharedModule],
})
export class AnchorTabDisplayComponent implements OnInit, AfterViewInit {
  @Input() inventory: ShopOffersInventory;
  @Input() user: User;
  sectionToGo = input<string>('');
  @Input() active: boolean;

  @HostListener('touchstart', ['$event'])
  public onTouchStart(event): void {
    this.currentMousePositionX = event.touches[0].pageX;
  }
  @HostListener('touchmove', ['$event'])
  public onTouchMove(event): void {
    this.lastTouchMovingPosition = event.touches[0].pageX;
  }
  @HostListener('touchend')
  public onTouchEnd(): void {
    if (this.currentMousePositionX - this.lastTouchMovingPosition < 0) {
      this.onTabClicked(0);
    } else if (this.currentMousePositionX - this.lastTouchMovingPosition > 0) {
      this.onTabClicked(1);
    }
  }
  @HostListener('mousedown', ['$event'])
  public onMouseDown(event): void {
    this.currentMousePositionX = event.clientX;
  }
  @HostListener('mouseup', ['$event'])
  public onMouseUp(event): void {
    if (this.currentMousePositionX - event.clientX < 0) {
      this.onTabClicked(0);
    } else if (this.currentMousePositionX - event.clientX > 0) {
      this.onTabClicked(1);
    }
  }

  selectedTab = signal('left');
  scrollTimer = -1;
  anchorElement: HTMLElement;
  isBeingPressed: boolean = false;

  currentMousePositionX: number;
  lastTouchMovingPosition: number;

  ngOnInit() {
    this.inventory = new ShopOffersInventory(this.inventory.Coins, this.inventory.Gems);
    this.anchorElement = document.getElementById('anchor-tab-container');
    this.anchorElement.scrollLeft = 0;
  }

  ngAfterViewInit() {
    if (this.sectionToGo() === 'left') {
      this.selectedTab.set('left');
    } else if (this.sectionToGo() === 'right') {
      this.selectedTab.set('right');
    }
  }

  public onTabClicked(tab: number) {
    switch (tab) {
      case 0:
        this.selectedTab.set('left');
        break;
      case 1:
        this.selectedTab.set('right');
        break;
      default:
        break;
    }
  }
}
